<script setup>
/**
 * "LIGAR" FORA DO TELEFONE (telefonia, etapa E2 — Victor, 25/09/2026): no
 * cabeçalho da conversa e na ficha do contato. Só aparece para quem tem ramal
 * e está com o telefone pronto — com o módulo desligado ou sem ramal, some.
 * O número vai como está no advup; o PBX converte (+55 27 99298-0043 →
 * 027992980043 na operadora com o formato "zero").
 */
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useTelefone, ligarDaTela } from './estado';

const props = defineProps({
  numero: { type: String, default: '' },
  nome: { type: String, default: '' },
  // 'acao' = ícone redondo (cabeçalho da conversa); 'botao' = com o rótulo
  jeito: { type: String, default: 'acao' },
});

const { t } = useI18n();
const telefone = useTelefone();

const visivel = computed(
  () => Boolean(props.numero) && telefone.fase === 'pronto'
);
const ocupado = computed(() => Boolean(telefone.chamada));
const rotulo = computed(() =>
  ocupado.value
    ? t('TELEFONE.EM_LIGACAO')
    : t('TELEFONE.LIGAR_PARA', { nome: props.nome || props.numero })
);

const ligar = () => ligarDaTela(props.numero, props.nome);
</script>

<template>
  <button
    v-if="visivel && jeito === 'acao'"
    v-tooltip="rotulo"
    type="button"
    class="advup-acao advup-acao--tingida advup-acao--t-teal ligar-botao"
    :aria-label="rotulo"
    :disabled="ocupado"
    @click="ligar"
  >
    <i class="i-ph-phone-fill" aria-hidden="true" />
  </button>
  <button
    v-else-if="visivel"
    v-tooltip="ocupado ? rotulo : ''"
    type="button"
    class="ligar-botao ligar-botao--rotulo"
    :disabled="ocupado"
    @click="ligar"
  >
    <i class="i-ph-phone-fill" aria-hidden="true" />
    {{ t('TELEFONE.LIGAR') }}
  </button>
</template>

<style scoped>
.ligar-botao:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.ligar-botao--rotulo {
  display: inline-flex;
  align-items: center;
  gap: var(--esp-1);
  height: 32px;
  padding: 0 var(--esp-3);
  border-radius: var(--r-3);
  font-size: var(--txt-nota);
  font-weight: var(--peso-forte);
  background: rgb(var(--teal-9));
  color: white;
  touch-action: manipulation;
  transition:
    background var(--mov-1) var(--mov-curva),
    transform var(--mov-1) var(--mov-curva);
}
.ligar-botao--rotulo:hover:not(:disabled) {
  background: rgb(var(--teal-10));
}
.ligar-botao--rotulo:active:not(:disabled) {
  transform: scale(0.97);
}
</style>
